import _ from 'lodash'
import React from 'react'
import { Grid } from 'semantic-ui-react'

const Rater = (props) => {
    return (
        <Grid className='rater'>
            <Grid.Row columns={10}>
                {
                    /* eslint-disable react/no-array-index-key */
                    _.range(1, 11)
                        .map((index) => {
                            let classes = ''
                            classes = `${classes} ${index === 1 ? 'first' : ''}`
                            classes = `${classes} ${index === 10 ? 'last' : ''}`
                            classes = `${classes} ${index <= props.value ? 'full' : ''}`
                            return (
                                <Grid.Column
                                    key={`cell${index}`}
                                    className={classes}
                                    onClick={
                                        (_e) => {
                                            if (!props.editable) {
                                                return
                                            }
                                            props.onChangeValue(index !== props.value ? index : index - 1)
                                        }
                                    }
                                >
                                    {index === 1 || index === 5 || index === 10 ? index : ''}
                                </Grid.Column>
                            )
                        })
                    /* eslint-enable react/no-array-index-key */
                }
            </Grid.Row>
        </Grid>
    )
}

export default Rater



// WEBPACK FOOTER //
// ./src/components/common/rater/index.js